import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '../components/Navbar';
import { TYPOGRAPHY } from '../constants/typography';

const CafeConnectionsPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>Café Connections - Studio Connect Café | HAV'N Interiors</title>
                <meta name="description" content="Where Ideas Brew, Designs Emerge, and Communities Connect. Chennai's first exclusive architects' café with a complete material library." />
            </Helmet>
            <style>{`
                .cafe-feature-card:hover {
                    transform: translateY(-5px);
                    border-color: var(--accent-color) !important;
                    box-shadow: 0 10px 30px rgba(201, 169, 110, 0.2);
                }
            `}</style>
            <Navbar />
            
            {/* Hero Banner with Video Background */}
            <div style={{
                position: 'relative',
                width: '100%',
                height: '70vh',
                minHeight: '500px',
                overflow: 'hidden',
                marginTop: '80px'
            }}>
                {/* Video Background */}
                <video 
                    autoPlay 
                    loop 
                    muted 
                    playsInline
                    style={{ 
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        zIndex: 1
                    }}
                >
                    <source src={`${process.env.PUBLIC_URL}/images/awards/cafe.mp4`} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                
                {/* Dark Overlay for better text readability */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 2
                }}></div>
                
                {/* Text Overlay */}
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    textAlign: 'center',
                    zIndex: 3,
                    width: '100%',
                    padding: '0 40px',
                    maxWidth: '1200px'
                }}>
                    {/*<div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
                        <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" strokeWidth="2">
                            <path d="M18 8h1a4 4 0 0 1 0 8h-1"/>
                            <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/>
                            <line x1="6" y1="1" x2="6" y2="4"/>
                            <line x1="10" y1="1" x2="10" y2="4"/>
                            <line x1="14" y1="1" x2="14" y2="4"/>
                        </svg>
                    </div>
                    <h1 style={{ ...TYPOGRAPHY.h2, color: 'var(--accent-color)', marginBottom: '15px', textShadow: '0 2px 10px rgba(0, 0, 0, 0.5)' }}>Café Connections</h1>
                    <p style={{ fontSize: '20px', color: 'var(--text-light)', fontWeight: 500, marginBottom: '10px', textShadow: '0 2px 10px rgba(0, 0, 0, 0.5)' }}>Studio Connect Café</p>
                    <p style={{ ...TYPOGRAPHY.body, maxWidth: '800px', margin: '0 auto', fontStyle: 'italic', textShadow: '0 2px 10px rgba(0, 0, 0, 0.5)' }}>
                        Where Ideas Brew, Designs Emerge, and Communities Connect
                    </p> */}
                </div>
            </div>

            <div style={{
                minHeight: '100vh',
                background: 'linear-gradient(180deg, #0A0A0A 0%, #0F0F0F 50%, #0A0A0A 100%)',
                paddingTop: '80px',
                paddingBottom: '100px'
            }}>
                <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 40px' }}>

                    {/* What is Café Connections */}
                    <div style={{ marginBottom: '40px', padding: '40px', background: 'rgba(201, 169, 110, 0.05)', borderRadius: '16px', border: '1px solid rgba(201, 169, 110, 0.2)' }}>
                        <h2 style={{ ...TYPOGRAPHY.h4, color: 'var(--accent-color)', marginBottom: '20px' }}>What is Café Connections?</h2>
                        <p style={{ ...TYPOGRAPHY.body, marginBottom: '25px' }}>
                            Café Connections is more than a café — it is a platform for networking, learning, and creative exchange. 
                            The city's first exclusive architects' café with a complete material library, offering a professional hub where design takes shape.
                        </p>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
                            <div style={{ padding: '20px', background: 'rgba(0, 0, 0, 0.3)', borderRadius: '12px', borderLeft: '3px solid var(--accent-color)' }}>
                                <div style={{ marginBottom: '10px' }}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" strokeWidth="2">
                                        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
                                        <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
                                        <line x1="12" y1="19" x2="12" y2="23"/>
                                        <line x1="8" y1="23" x2="16" y2="23"/>
                                    </svg>
                                </div>
                                <p style={{ ...TYPOGRAPHY.body, fontSize: '15px', margin: 0 }}>
                                    A stage for seminars, workshops, and design talks
                                </p>
                            </div>
                            <div style={{ padding: '20px', background: 'rgba(0, 0, 0, 0.3)', borderRadius: '12px', borderLeft: '3px solid var(--accent-color)' }}>
                                <div style={{ marginBottom: '10px' }}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" strokeWidth="2">
                                        <circle cx="13.5" cy="6.5" r=".5"/>
                                        <circle cx="17.5" cy="10.5" r=".5"/>
                                        <circle cx="8.5" cy="7.5" r=".5"/>
                                        <circle cx="6.5" cy="12.5" r=".5"/>
                                        <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/>
                                    </svg>
                                </div>
                                <p style={{ ...TYPOGRAPHY.body, fontSize: '15px', margin: 0 }}>
                                    An experience studio to explore, touch, and interact with diverse material solutions
                                </p>
                            </div>
                            <div style={{ padding: '20px', background: 'rgba(0, 0, 0, 0.3)', borderRadius: '12px', borderLeft: '3px solid var(--accent-color)' }}>
                                <div style={{ marginBottom: '10px' }}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" strokeWidth="2">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                                        <circle cx="9" cy="7" r="4"/>
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                                    </svg>
                                </div>
                                <p style={{ ...TYPOGRAPHY.body, fontSize: '15px', margin: 0 }}>
                                    A meeting point for architects, interior designers, institutes, and students to collaborate
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Philosophy */}
                    <div style={{ marginBottom: '40px', padding: '30px', background: 'rgba(201, 169, 110, 0.1)', borderRadius: '16px', border: '1px solid var(--accent-color)' }}>
                        <h2 style={{ ...TYPOGRAPHY.h4, color: 'var(--accent-color)', marginBottom: '20px', textAlign: 'center' }}>Our Philosophy</h2>
                        <p style={{ ...TYPOGRAPHY.body, textAlign: 'center', marginBottom: '25px' }}>
                            Café Connections is founded on three core pillars:
                        </p>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', textAlign: 'center' }}>
                            <div style={{ padding: '20px' }}>
                                <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'center' }}>
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" strokeWidth="2">
                                        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
                                    </svg>
                                </div>
                                <h3 style={{ ...TYPOGRAPHY.h4, fontSize: '20px', color: 'var(--accent-color)', marginBottom: '10px' }}>Fun</h3>
                                <p style={{ ...TYPOGRAPHY.body, fontSize: '14px' }}>A vibrant, inspiring atmosphere that celebrates creativity</p>
                            </div>
                            <div style={{ padding: '20px' }}>
                                <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'center' }}>
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" strokeWidth="2">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                                        <circle cx="9" cy="7" r="4"/>
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                                    </svg>
                                </div>
                                <h3 style={{ ...TYPOGRAPHY.h4, fontSize: '20px', color: 'var(--accent-color)', marginBottom: '10px' }}>Networking</h3>
                                <p style={{ ...TYPOGRAPHY.body, fontSize: '14px' }}>A collaborative hub connecting the design fraternity</p>
                            </div>
                            <div style={{ padding: '20px' }}>
                                <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'center' }}>
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" strokeWidth="2">
                                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                                        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                                    </svg>
                                </div>
                                <h3 style={{ ...TYPOGRAPHY.h4, fontSize: '20px', color: 'var(--accent-color)', marginBottom: '10px' }}>Education</h3>
                                <p style={{ ...TYPOGRAPHY.body, fontSize: '14px' }}>A living classroom where global ideas meet practical applications</p>
                            </div>
                        </div>
                    </div>

                    {/* Features & Enhancements */}
                    <div>
                        <h2 style={{ ...TYPOGRAPHY.h4, color: 'var(--accent-color)', marginBottom: '30px', textAlign: 'center' }}>Features & Enhancements</h2>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
                            {[
                                { icon: 'book', title: 'Design Library', desc: 'An archive of books, journals, and global references on interiors, architecture, and art' },
                                { icon: 'monitor', title: 'Digital Panels & VR', desc: 'Interactive displays to explore projects and design catalogs' },
                                { icon: 'palette', title: 'Material Experience Corners', desc: 'A hands-on showcase of laminates, veneers, flooring, textiles, and finishes' },
                                { icon: 'message', title: 'Talk Corners', desc: 'Dedicated zones for intimate seminars, discussions, and networking meets' },
                                { icon: 'coffee', title: 'Coffee & Conversations Lounge', desc: 'A relaxed environment for creative dialogue' },
                                { icon: 'art', title: 'Art & Design Showcase', desc: 'Rotating exhibits featuring professional works and student projects' }
                            ].map((feature, idx) => (
                                <div key={idx} style={{ padding: '25px', background: 'rgba(0, 0, 0, 0.3)', borderRadius: '12px', border: '1px solid rgba(201, 169, 110, 0.2)', transition: 'all 0.3s ease' }} className="cafe-feature-card">
                                    <div style={{ marginBottom: '15px' }}>
                                        {feature.icon === 'book' && (
                                            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" strokeWidth="2">
                                                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                                                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                                            </svg>
                                        )}
                                        {feature.icon === 'monitor' && (
                                            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" strokeWidth="2">
                                                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                                                <line x1="8" y1="21" x2="16" y2="21"/>
                                                <line x1="12" y1="17" x2="12" y2="21"/>
                                            </svg>
                                        )}
                                        {feature.icon === 'palette' && (
                                            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" strokeWidth="2">
                                                <circle cx="13.5" cy="6.5" r=".5"/>
                                                <circle cx="17.5" cy="10.5" r=".5"/>
                                                <circle cx="8.5" cy="7.5" r=".5"/>
                                                <circle cx="6.5" cy="12.5" r=".5"/>
                                                <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/>
                                            </svg>
                                        )}
                                        {feature.icon === 'message' && (
                                            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" strokeWidth="2">
                                                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                                            </svg>
                                        )}
                                        {feature.icon === 'coffee' && (
                                            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" strokeWidth="2">
                                                <path d="M18 8h1a4 4 0 0 1 0 8h-1"/>
                                                <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/>
                                                <line x1="6" y1="1" x2="6" y2="4"/>
                                                <line x1="10" y1="1" x2="10" y2="4"/>
                                                <line x1="14" y1="1" x2="14" y2="4"/>
                                            </svg>
                                        )}
                                        {feature.icon === 'art' && (
                                            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" strokeWidth="2">
                                                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                                                <circle cx="8.5" cy="8.5" r="1.5"/>
                                                <polyline points="21 15 16 10 5 21"/>
                                            </svg>
                                        )}
                                    </div>
                                    <h3 style={{ ...TYPOGRAPHY.h4, fontSize: '18px', color: 'var(--accent-color)', marginBottom: '10px' }}>{feature.title}</h3>
                                    <p style={{ ...TYPOGRAPHY.body, fontSize: '14px', margin: 0, lineHeight: '1.6' }}>{feature.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <footer>
                <img src={`${process.env.PUBLIC_URL}/current-logo.png`} alt="Hav'n Interiors" className="footer-logo" />
                <p>&copy; 2025 Hav'n Interiors & Global Sourcing. All Rights Reserved.</p>
                <p style={{ marginTop: '10px', fontSize: '12px', opacity: 0.6 }}>Innovate. Integrate. Execute.</p>
            </footer>
        </>
    );
};



export default CafeConnectionsPage;

